(function(){
  const ZOOM = 10; // keep in sync with background-size (ZOOM * 100%)

  // Utility: strip Shopify size suffix (_416x, _1024x1024, etc.)
  const fullSrc = (img) => {
    if (!img) return '';
    let src = (img.currentSrc || img.src || img.getAttribute('data-src') || '').trim();
    return src.replace(/_(\d+x\d+|\d+x)\.(jpe?g|png|webp|gif)(\?.*)?$/i, '.$2$3');
  };

  // Get the current visible slide's IMG (skip videos/3D)
  function getActiveImage() {
    const active =
      document.querySelector('.product__media-item.slider__slide.is-active') ||
      document.querySelector('.product__media-item[aria-hidden="false"]') ||
      document.querySelector('.product__media-item');

    if (!active) return null;
    const img = active.querySelector('img');
    // ignore non-images (video/model-viewer)
    if (!img || active.querySelector('video, model-viewer')) return null;
    return img;
  }

  // Ensure the glass exists in the gallery container
  function ensureGlass() {
    let glass = document.getElementById('au-magnify-glass');
    if (!glass) {
      const wrapper = document.querySelector('.product__media-wrapper') ||
                      document.querySelector('.product__media-list');
      if (!wrapper) return null;
      glass = document.createElement('div');
      glass.id = 'au-magnify-glass';
      wrapper.appendChild(glass);
    }
    return glass;
  }

  function bindHover() {
    const img = getActiveImage();
    const glass = ensureGlass();
    const gallery = document.querySelector('.product__media-list');
    if (!img || !glass || !gallery) { if (glass) glass.style.display = 'none'; return; }

    // set background to the *full* image
    glass.style.backgroundImage = `url("${fullSrc(img)}")`;
    glass.style.backgroundSize = `${ZOOM * 100}%`;

    // move/focus glass on pointer move over the active slide (the img’s parent li)
    const slide = img.closest('.product__media-item');
    if (!slide) return;

    // remove previous listeners to avoid stacking
    slide.onmousemove = (e) => {
      const slideRect = slide.getBoundingClientRect();         // where the image is
      const wrapRect  = glass.parentElement.getBoundingClientRect(); // where the glass is positioned

      // mouse relative to slide (for background %)
      const sx = e.clientX - slideRect.left;
      const sy = e.clientY - slideRect.top;
      const sw = slideRect.width, sh = slideRect.height;

      if (sx <= 0 || sx >= sw || sy <= 0 || sy >= sh) { glass.style.display = 'none'; return; }

      // mouse relative to wrapper (for absolute left/top)
      const wx = e.clientX - wrapRect.left;
      const wy = e.clientY - wrapRect.top;

      const r = glass.offsetWidth / 2;
      const bgX = (sx / sw) * 100;
      const bgY = (sy / sh) * 100;

      glass.style.left = (wx - r) + 'px';
      glass.style.top  = (wy - r) + 'px';
      glass.style.backgroundPosition = `${bgX}% ${bgY}%`;
      glass.style.display = 'block';
    };

    slide.onmouseleave = () => { glass.style.display = 'none'; };

    // if src swaps due to lazy/srcset, refresh background
    img.addEventListener('load', () => {
      glass.style.backgroundImage = `url("${fullSrc(img)}")`;
    }, { once:false });
  }

  function installObservers() {
    const gallery = document.querySelector('.product__media-list');
    if (!gallery) return;

    // Rebind when gallery DOM changes (slide switch, variant change, lazy load)
    const mo = new MutationObserver(() => setTimeout(bindHover, 50));
    mo.observe(gallery, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'src', 'srcset', 'currentSrc', 'aria-hidden']
    });

    // Common theme events
    document.addEventListener('shopify:section:load', bindHover);
    document.addEventListener('shopify:block:select', bindHover);
    document.addEventListener('shopify:block:deselect', bindHover);
    document.addEventListener('variant:change', bindHover);
    document.addEventListener('media:change', bindHover);

    // Initial bind
    bindHover();
  }

  // Start
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', installObservers);
  } else {
    installObservers();
  }
})();
